import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-defined-benefit',
    templateUrl: 'efast-filter-defined-benefit.component.html',
    styleUrls: ['efast-filter-defined-benefit.component.css'],
    standalone: false
})

export class EfastFilterDefinedBenefitComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {

        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().DEFINED_BENEFIT;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl1'),
            this.staticsService.getPlanCodeFilter().CODE_TYPE_BENEFIT, false))
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl2'),
            this.staticsService.getPlanCodeFilter().CODE_1A));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl3'),
            this.staticsService.getPlanCodeFilter().CODE_1B));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl4'),
            this.staticsService.getPlanCodeFilter().CODE_1C));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl5'),
            this.staticsService.getPlanCodeFilter().CODE_1D));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl6'),
            this.staticsService.getPlanCodeFilter().CODE_1E));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl7'),
            this.staticsService.getPlanCodeFilter().CODE_1F));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl8'),
            this.staticsService.getPlanCodeFilter().CODE_1G));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl9'),
            this.staticsService.getPlanCodeFilter().CODE_1H));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl10'),
            this.staticsService.getPlanCodeFilter().CODE_1I));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl11'),
            this.staticsService.getPlanCodeFilter().CODE_1J));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl12'),
            this.staticsService.getPlanCodeFilter().CODE_1K));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedBenefitLbl13'),
            this.staticsService.getPlanCodeFilter().CODE_1L));
        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.plancode.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_CODE, this.queryValue, true)
    }
}